import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "consultation-request-success-modal__icon-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "consultation-request-success-modal__title" }
const _hoisted_4 = { class: "consultation-request-success-modal__description" }

import { computed } from 'vue';

const DEFAULT_DESCRIPTION =
  'Спасибо! Мы получили Ваше обращение и рассмотрим его в ближайшее время.';


export default /*@__PURE__*/_defineComponent({
  __name: 'consultation-request-success-modal',
  props: {
    open: { type: Boolean },
    title: { default: 'Заявка отправлена' },
    description: { default: '' },
    continueLabel: { default: 'Продолжить' },
    onContinue: {}
  },
  emits: ["update:open"],
  setup(__props: any, { emit: __emit }) {

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const props = __props;

const displayDescription = computed(() => {
  const fromApi = props.description?.trim();
  return fromApi || DEFAULT_DESCRIPTION;
});

const emit = __emit;

const onContinue = () => {
  emit('update:open', false);

  props.onContinue?.();
};

return (_ctx: any,_cache: any) => {
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    open: props.open,
    centered: "",
    class: "consultation-request-success-modal",
    "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => (emit('update:open', $event))),
    width: "400"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        class: "btn btn-outline consultation-request-success-modal__action",
        type: "button",
        onClick: onContinue
      }, _toDisplayString(props.continueLabel), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: `${_unref(ICONS_BASE)}/ok.svg`,
          alt: ""
        }, null, 8, _hoisted_2)
      ]),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(props.title), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(displayDescription.value), 1)
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})